import Reveal from "@stimulus-components/reveal";

export default class extends Reveal {
  static targets = ["item", "button"];
  static classes = ["hidden", "activeBackground", "buttonHide", "buttonShow"];

  connect() {
    super.connect();
  }

  toggle() {
    super.toggle();

    if (this.hasActiveBackgroundClass) {
      this.element.classList.toggle(this.activeBackgroundClass);
    }

    if (this.hasButtonTarget && this.hasButtonShowClass) {
      this.buttonTarget
        .querySelector("i")
        .classList.toggle(this.buttonShowClass);
    }

    if (this.hasButtonTarget && this.hasButtonHideClass) {
      this.buttonTarget
        .querySelector("i")
        .classList.toggle(this.buttonHideClass);
    }
  }
}
